// import React, { useState, useEffect } from "react";
// import { Modal, Input, Button, Checkbox, List, Space, Select } from "antd";
// import { post } from "../services/services";
// import { ErrorToast, SuccessToast } from "../widgets/AppToast";
// import { ApiURL } from "../services/apiConstants";

// const { Option } = Select;

// const LogbookModal = ({ visible, onClose, onSave, company_id }) => {
//   const [duration, setDuration] = useState(null);
//   const [logbooks, setLogbooks] = useState([]);
//   const [selected, setSelected] = useState([]);
//   const [newLogbook, setNewLogbook] = useState("");

//   const fetchLogbooks = (company_id) => {
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("company_id", company_id);
//       post(ApiURL.logbooks_list, FORM_DATA).then((res) => {
//         if (res?.status == true) {
//           setLogbooks(res?.data);
//         } else {
//           ErrorToast("Error", res?.message);
//         }
//       });
//     } catch (error) {
//       console.error("Error fetching logbooks:", error);
//     }
//   };

//   useEffect(() => {
//     if (company_id) {
//       fetchLogbooks(company_id);
//     }
//   }, [company_id]);

//   const handleAdd = async () => {
//     const trimmed = newLogbook.trim();
//     if (!trimmed) return;
//     try {
//       const formData = new FormData();
//       formData.append("name", trimmed);
//       const data = await post(ApiURL.add_logbook, formData);
//       if (!data || data.error) {
//         throw new Error("Failed to add logbook");
//       }
//       fetchLogbooks(company_id);
//       setLogbooks((prev) => [...prev, data]);
//       setNewLogbook("");
//     } catch (error) {
//       console.error("Error adding logbook:", error);
//     }
//   };

//   const handleRemove = async (id) => {
//     try {
//       const formData = new FormData();
//       formData.append("id", id);
//       const data = await post(ApiURL.delete_logbook, formData);
//       if (!data || data.status === false || data.error) {
//         throw new Error(data?.message || "Failed to delete logbook");
//       }
//       SuccessToast("success", "Logbook deleted successfully!");
//       setLogbooks((prev) => prev.filter((item) => item.id !== id));
//       setSelected((prev) => prev.filter((sel) => sel.id !== id));
//       fetchLogbooks(company_id);
//     } catch (error) {
//       console.error("Error deleting logbook:", error);
//       ErrorToast("error", "Failed to delete logbook. Please try again.");
//     }
//   };

//   // Toggle checkbox
//   const handleToggle = (item, checked) => {
//     setSelected((prev) =>
//       checked ? [...prev, item] : prev.filter((sel) => sel.id !== item.id)
//     );
//   };

//   // Save selected logbooks
//   const handleSave = () => {
//     if (!duration) {
//       ErrorToast("Error", "Please select subscription duration");
//       return;
//     }
//     onSave({ logbooks: selected, duration });
//     onClose();
//   };

//   const subscriptionOptions = [
//     { label: "1 Month", value: 1 },
//     { label: "3 Months", value: 3 },
//     { label: "6 Months", value: 6 },
//     { label: "12 Months", value: 12 },
//   ];

//   return (
//     <>
//       {/* {contextHolder} */}
//       <Modal
//         title="Select Logbooks"
//         open={visible}
//         onCancel={onClose}
//         onOk={handleSave}
//         okText="Save"
//       >
//         <Space direction="vertical" style={{ width: "100%" }}>
//           {/* Subscription duration dropdown */}
//           <Select
//             placeholder="Select subscription duration"
//             value={duration}
//             onChange={setDuration}
//             style={{ width: "100%" }}
//           >
//             {subscriptionOptions.map((opt) => (
//               <Option key={opt.value} value={opt.value}>
//                 {opt.label}
//               </Option>
//             ))}
//           </Select>

//           {/* Add new logbook */}
//           {/* <Space.Compact style={{ width: "100%" }}>
//           <Input
//             placeholder="Enter logbook name"
//             value={newLogbook}
//             onChange={(e) => setNewLogbook(e.target.value)}
//             onPressEnter={handleAdd}
//           />
//           <Button type="primary" onClick={handleAdd} icon={<PlusOutlined />}>
//             Add
//           </Button>
//         </Space.Compact> */}

//           {/* Logbook list */}
//           <List
//             style={{
//               maxHeight: "300px",
//               overflowY: "auto",
//               width: "100%",
//               marginBottom: "10px",
//             }}
//             dataSource={logbooks}
//             bordered
//             renderItem={(item) => (
//               <List.Item
//                 key={item.id}
//                 // actions={[
//                 //   <Button
//                 //     danger
//                 //     type="text"
//                 //     icon={<DeleteOutlined />}
//                 //     onClick={() => handleRemove(item.id)}
//                 //   />,
//                 // ]}
//               >
//                 <Checkbox
//                   checked={selected.some((sel) => sel.id === item.id)}
//                   onChange={(e) => handleToggle(item, e.target.checked)}
//                 >
//                   {item.name}
//                 </Checkbox>
//               </List.Item>
//             )}
//           />
//         </Space>
//       </Modal>
//     </>
//   );
// };

// export default LogbookModal;


// import React, { useState, useEffect } from "react";
// import { Modal, Select, Checkbox, Divider, Typography } from "antd";
// import { post } from "../services/services";
// import { ApiURL, baseURL } from "../services/apiConstants";
// import { ErrorToast, SuccessToast } from "../widgets/AppToast";

// const { Option } = Select;
// const { Text, Title } = Typography;

// const LogbookModal = ({ visible, onClose, companyId, refreshList }) => {
//   const [selectedType, setSelectedType] = useState(null);
//   const [duration, setDuration] = useState(null);
//   const [selectedModules, setSelectedModules] = useState([]);
//   const [packages, setPackages] = useState([]);
//   const [pricing, setPricing] = useState(null);
//   const [customModulesList, setCustomModulesList] = useState([]);
//   const [ships, setShips] = useState([]);
//   const [selectedShips, setSelectedShips] = useState([]);
//   const [loadingPackages, setLoadingPackages] = useState(false);
//   const [loadingShips, setLoadingShips] = useState(false);

//   useEffect(() => {
//     if (visible) {
//       fetchPackages();
//       fetchShipsByCompany(companyId);
//     }
//   }, [visible]);

//   const fetchPackages = async () => {
//     try {
//       setLoadingPackages(true);
//       const res = await post(`${baseURL}${ApiURL.packages_list}`, {});
//       if (res?.status) {
//         setPackages(res?.packages || []);
//       }
//     } finally {
//       setLoadingPackages(false);
//     }
//   };

//   const fetchShipsByCompany = async (companyId) => {
//     try {
//       setLoadingShips(true);
//       const res = await post(`${baseURL}${ApiURL.get_ships_by_company}`, {
//         company_id: companyId,
//       });

//       if (res?.status) {
//         setShips(res?.ships || []);
//       } else {
//         ErrorToast("Error", "Failed to fetch ships");
//       }
//     } catch {
//       ErrorToast("Error", "Failed to fetch ships");
//     } finally {
//       setLoadingShips(false);
//     }
//   };

//   const fetchPricing = async (payload) => {
//     try {
//       const res = await post(`${baseURL}${ApiURL.price_selection}`, payload);
//       if (res?.status) {
//         setPricing(res);
//         setCustomModulesList(res?.custom_options || []);
//       }
//     } catch {
//       ErrorToast("Error", "Failed to fetch pricing");
//     }
//   };

//   // ---------------- 📌 FINAL HANDLE SAVE WITH API ----------------
//   const handleSave = async () => {
//     if (!duration) {
//       ErrorToast("Error", "Please select duration");
//       return;
//     }

//     if (selectedShips.length === 0) {
//       ErrorToast("Error", "Please select at least one ship");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("company_id", companyId);
//     formData.append("months", duration);

//     // ships[]
//     selectedShips.forEach((id) => {
//       formData.append("ships[]", id);
//     });

//     // package
//     if (selectedType !== "custom") {
//       formData.append("package_module_id", selectedType);
//     }

//     // custom modules
//     if (selectedType === "custom") {
//       selectedModules.forEach((m) => {
//         formData.append("custom_options[]", m.id); // ← m.id is correct
//       });
//     }

//     try {
//       const res = await post(`${baseURL}${ApiURL.add_logbook}`, formData);

//       if (res?.status) {
//         SuccessToast("Success", "Selected logbook created successfully!");
//         onClose();
//         refreshList(); // refresh main list
//       } else {
//         ErrorToast("Error", res?.message || "Failed to add logbook");
//       }
//     } catch {
//       ErrorToast("Error", "Failed to add logbook");
//     }
//   };

//   const handleModuleSelection = (value) => {
//     setSelectedType(value);
//     setDuration(null);
//     setSelectedModules([]);
//     setPricing(null);
//   };

//   const handleDurationChange = (value) => {
//     setDuration(value);

//     if (selectedType === "custom") {
//       fetchPricing({ custom: true, month: value });
//     } else {
//       fetchPricing({ package_module_id: selectedType, month: value });
//     }
//   };

//   const handleCustomModuleSelection = (e, module) => {
//     if (e.target.checked) {
//       setSelectedModules([...selectedModules, module]);
//     } else {
//       setSelectedModules(selectedModules.filter((m) => m.id !== module.id));
//     }
//   };

//   return (
//     <Modal
//       title="Select Logbooks"
//       open={visible}
//       onCancel={onClose}
//       onOk={handleSave}
//       okText="Save"
//       width={750}
//     >
//       <Title level={5}>Select Ship</Title>

//       <Select
//         mode="multiple"
//         placeholder="Select Ship(s)"
//         style={{ width: "100%", marginBottom: "15px" }}
//         loading={loadingShips}
//         value={selectedShips}
//         onChange={(value) => setSelectedShips(value)}
//       >
//         {ships.map((ship) => (
//           <Option key={ship?.id} value={ship?.id}>
//             {ship?.vessel_name}
//           </Option>
//         ))}
//       </Select>

//       <Divider />

//       <Title level={5}>Select Package or Custom Modules</Title>

//       <Select
//         placeholder="Select Type"
//         style={{ width: "100%" }}
//         onChange={handleModuleSelection}
//       >
//         {packages?.map((pkg) => (
//           <Option key={pkg?.id} value={pkg?.id}>
//             {pkg?.module_name}
//           </Option>
//         ))}
//         <Option value="custom">Custom Modules</Option>
//       </Select>

//       <Divider />

//       {selectedType && (
//         <>
//           <Title level={5}>Select Duration</Title>
//           <Select
//             value={duration}
//             onChange={handleDurationChange}
//             placeholder="Select Months"
//             style={{ width: "100%", marginBottom: "10px" }}
//           >
//             <Option value={1}>1 Month</Option>
//             <Option value={3}>3 Months</Option>
//             <Option value={6}>6 Months</Option>
//             <Option value={12}>12 Months</Option>
//           </Select>

//           <Divider />
//         </>
//       )}

//       {selectedType !== "custom" && duration && pricing && (
//         <>
//           <Title level={5}>Modules Included</Title>

//           {pricing?.items?.map((module) => (
//             <div
//               key={module.id}
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 padding: "10px 0",
//                 borderBottom: "1px solid #eee",
//               }}
//             >
//               <Text>{module.Feature}</Text>
//               <Text strong>${module.price}</Text>
//             </div>
//           ))}

//           <Divider />
//           <Title level={5}>Total Price: ${pricing?.total_price}</Title>
//         </>
//       )}

//       {selectedType === "custom" && duration && (
//         <>
//           <Title level={5}>Select Custom Modules</Title>

//           <div style={{ maxHeight: "300px", overflowY: "auto" }}>
//             {customModulesList?.map((module) => (
//               <div
//                 key={module.id}
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   padding: "10px 0",
//                   borderBottom: "1px solid #eee",
//                 }}
//               >
//                 <Checkbox
//                   checked={selectedModules.some((i) => i.id === module.id)}
//                   onChange={(e) => handleCustomModuleSelection(e, module)}
//                 >
//                   {module.Feature}
//                 </Checkbox>

//                 <Text strong>${module.price}</Text>
//               </div>
//             ))}
//           </div>

//           <Divider />
//           <Title level={5}>
//             Total Price: $
//             {selectedModules.reduce((total, module) => total + module.price, 0)}
//           </Title>
//         </>
//       )}
//     </Modal>
//   );
// };

// export default LogbookModal;



import React, { useState, useEffect } from "react";
import { Modal, Select, Checkbox, Divider, Typography, Button, Tooltip } from "antd";
import { post } from "../services/services";
import { ApiURL, baseURL } from "../services/apiConstants";
import { ErrorToast, SuccessToast } from "../widgets/AppToast";

const { Option } = Select;
const { Text, Title } = Typography;

const LogbookModal = ({ visible, onClose, companyId, refreshList }) => {
  const [selectedType, setSelectedType] = useState(null);
  const [duration, setDuration] = useState(null);
  const [selectedModules, setSelectedModules] = useState([]);
  const [packages, setPackages] = useState([]);
  const [pricing, setPricing] = useState(null);
  const [customModulesList, setCustomModulesList] = useState([]);
  const [ships, setShips] = useState([]);
  const [selectedShips, setSelectedShips] = useState([]);
  const [loadingPackages, setLoadingPackages] = useState(false);
  const [loadingShips, setLoadingShips] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  

  useEffect(() => {
    if (visible) {
      resetState();
      fetchPackages();
      fetchShipsByCompany(companyId);
    }
  }, [visible]);

  const fetchPackages = async () => {
    try {
      setLoadingPackages(true);
      const res = await post(`${baseURL}${ApiURL.packages_list}`, {});
      if (res?.status) {
        setPackages(res?.packages || []);
      }
    } finally {
      setLoadingPackages(false);
    }
  };

  const fetchShipsByCompany = async (companyId) => {
    try {
      setLoadingShips(true);
      const res = await post(`${baseURL}${ApiURL.get_ships_by_company}`, {
        company_id: companyId,
      });

      if (res?.status) {
        setShips(res?.ships || []);
      } else {
        ErrorToast("Error", "Failed to fetch ships");
      }
    } catch {
      ErrorToast("Error", "Failed to fetch ships");
    } finally {
      setLoadingShips(false);
    }
  };

  const fetchPricing = async (payload) => {
    try {
      const res = await post(`${baseURL}${ApiURL.price_selection}`, payload);
      if (res?.status) {
        setPricing(res);
        setCustomModulesList(res?.custom_options || []);
      }
    } catch {
      ErrorToast("Error", "Failed to fetch pricing");
    }
  };

  const buildQueryParams = () => {
    if (!duration || selectedShips.length === 0) return null;

    let params = "";

    // ships
    selectedShips.forEach((id) => {
      params += `&ships=${id}`;
    });

    // package
    if (selectedType !== "custom") {
      params += `&package_id=${selectedType}`;
    }

    // custom
    if (selectedType === "custom") {
      selectedModules.forEach((m) => {
        params += `&custom=${m.id}`;
      });
    }

    return params;
  };

  // ------------------ PREVIEW ------------------
  const handlePreview = () => {
      if (isActionDisabled()) {
    ErrorToast("Error", "Please select ship, duration and required modules");
    return;
  }
    const query = buildQueryParams();
    if (!query) {
      ErrorToast("Error", "Please select duration & ships");
      return;
    }

    const url = `${baseURL}/admin-api/invoice-preview/${companyId}/${duration}/?${query.substring(
      1
    )}`;

    window.open(url, "_blank");
  };

  // ------------------ DOWNLOAD ------------------
  const handleDownload = () => {
      if (isActionDisabled()) {
    ErrorToast("Error", "Please select ship, duration and required modules");
    return;
  }
    const query = buildQueryParams();
    if (!query) {
      ErrorToast("Error", "Please select duration & ships");
      return;
    }

    const url = `${baseURL}/admin-api/invoice-download/${companyId}/${duration}/?${query.substring(
      1
    )}`;

    window.open(url, "_blank");
  };

  // ------------------ SEND EMAIL ------------------
const handleSendEmail = async () => {
  if (isActionDisabled()) {
    ErrorToast("Error", "Please select ship, duration and required modules");
    return;
  }

  const formData = new FormData();
  formData.append("company_id", companyId);
  formData.append("months", duration);

  // ships[]
  selectedShips.forEach((id) => {
    formData.append("ships[]", id);
  });

  // package
  if (selectedType !== "custom") {
    formData.append("package_module_id", selectedType);
  }

  // custom modules
  if (selectedType === "custom") {
    selectedModules.forEach((m) => {
      formData.append("custom_options[]", m.id);
    });
  }

  try {
    // 🔥 using ApiURL constant properly
    const res = await post(`${baseURL}${ApiURL.invoice_email}`, formData);

    if (res?.status) {
      SuccessToast("Success", "Invoice emailed successfully!");
    } else {
      ErrorToast("Error", res?.message || "Failed to send email");
    }
  } catch (err) {
    ErrorToast("Error", "Something went wrong while sending invoice email");
  }
};



  // ------------------ SAVE LOGBOOK ------------------
  const handleSave = async () => {
    if (!duration) {
      ErrorToast("Error", "Please select duration");
      return;
    }

    if (selectedShips.length === 0) {
      ErrorToast("Error", "Please select at least one ship");
      return;
    }

    const formData = new FormData();
    formData.append("company_id", companyId);
    formData.append("months", duration);

    selectedShips.forEach((id) => {
      formData.append("ships[]", id);
    });

    if (selectedType !== "custom") {
      formData.append("package_module_id", selectedType);
    }

    if (selectedType === "custom") {
      selectedModules.forEach((m) => {
        formData.append("custom_options[]", m.id);
      });
    }

    try {
      const res = await post(`${baseURL}${ApiURL.add_logbook}`, formData);

      if (res?.status) {
        // SuccessToast("Success", "Selected logbook created successfully!");
        SuccessToast("Success", "Modules assigned successfully!");
        setIsSaved(true); 
        // onClose();
        refreshList();
      } else {
        ErrorToast("Error", res?.message || "Failed to add logbook");
      }
    } catch {
      ErrorToast("Error", "Failed to add logbook");
    }
  };

  const handleModuleSelection = (value) => {
    setSelectedType(value);
    setDuration(null);
    setSelectedModules([]);
    setPricing(null);
  };

  const handleDurationChange = (value) => {
    setDuration(value);

    if (selectedType === "custom") {
      fetchPricing({ custom: true, month: value });
    } else {
      fetchPricing({ package_module_id: selectedType, month: value });
    }
  };

  const handleCustomModuleSelection = (e, module) => {
    if (e.target.checked) {
      setSelectedModules([...selectedModules, module]);
    } else {
      setSelectedModules(selectedModules.filter((m) => m.id !== module.id));
    }
  };

  const isActionDisabled = () => {
  // Required fields missing
  if (!duration || selectedShips.length === 0 || !selectedType) return true;

  // Custom requires at least one module
  if (selectedType === "custom" && selectedModules.length === 0) return true;

  return false;
};


const resetState = () => {
  setSelectedType(null);
  setDuration(null);
  setSelectedModules([]);
  setPricing(null);
  setCustomModulesList([]);
  setSelectedShips([]);
  setIsSaved(false);  
};

  return (
    <Modal
      // title="Select Logbooks"
      open={visible}
      onCancel={onClose}
      onOk={handleSave}
      okText="Save"
      width={750}
      // footer={[

      //   /* NEW BUTTONS */
      //   <Button key="preview" type="default" onClick={handlePreview}>
      //     Preview
      //   </Button>,

      //   <Button key="download" type="default" onClick={handleDownload}>
      //     Download
      //   </Button>,

      //   <Button key="email" type="default" onClick={handleSendEmail}>
      //     Send Email
      //   </Button>,

      //   <Button key="save" type="primary" onClick={handleSave}>
      //     Save
      //   </Button>,

      //   <Button key="cancel" type="primary" onClick={onClose}>
      //     Cancel
      //   </Button>,
      // ]}
      footer={[
  <Button key="preview" disabled={isActionDisabled()} onClick={handlePreview}>
    Preview
  </Button>,

  <Button key="download" disabled={isActionDisabled()} onClick={handleDownload}>
    Download
  </Button>,

  // <Button key="email" disabled={isActionDisabled()} onClick={handleSendEmail}>
  //   Send Email
  // </Button>,

   <Tooltip 
    title={!isSaved ? "Please save the logbook first" : ""} 
    placement="top"
  >
    <Button 
      key="email"
      disabled={isActionDisabled() || !isSaved}
      onClick={handleSendEmail}
    >
      Send Email
    </Button>
  </Tooltip>,

  <Button key="save" type="primary" onClick={handleSave}>
    Save
  </Button>,

  <Button key="cancel" onClick={onClose}>
    Cancel
  </Button>,
]}

    >
      {/* ---------- UI remains unchanged ---------- */}

      <Title level={5}>Select Ship</Title>

      <Select
        mode="multiple"
        disabled={isSaved}
        placeholder="Select Ship(s)"
        style={{ width: "100%", marginBottom: "15px" }}
        loading={loadingShips}
        value={selectedShips}
        onChange={(value) => setSelectedShips(value)}
      >
        {ships.map((ship) => (
          <Option key={ship?.id} value={ship?.id}>
            {ship?.vessel_name}
          </Option>
        ))}
      </Select>

      <Divider />

      <Title level={5}>Select Package or Custom Modules</Title>

      {/* <Select
        placeholder="Select Type"
        style={{ width: "100%" }}
        onChange={handleModuleSelection}
      >
      
        {packages?.map((pkg) => (
          <Option key={pkg?.id} value={pkg?.id}>
            {pkg?.module_name}
          </Option>
        ))}
        <Option value="custom">Custom Modules</Option>
      </Select> */}
      <Select
        disabled={isSaved}
  placeholder="Select Package or Custom Modules"
  style={{ width: "100%" }}
  value={selectedType}     // <-- important fix
  onChange={handleModuleSelection}
  allowClear
>
  {packages?.map((pkg) => (
    <Option key={pkg?.id} value={pkg?.id}>
      {pkg?.module_name}
    </Option>
  ))}
  <Option value="custom">Custom Modules</Option>
</Select>


      <Divider />

      {selectedType && (
        <>
          <Title level={5}>Select Duration</Title>
          <Select
            disabled={isSaved}
            value={duration}
            onChange={handleDurationChange}
            placeholder="Select Months"
            style={{ width: "100%", marginBottom: "10px" }}
          >
            <Option value={1}>1 Month</Option>
            <Option value={3}>3 Months</Option>
            <Option value={6}>6 Months</Option>
            <Option value={12}>12 Months</Option>
          </Select>

          <Divider />
        </>
      )}

      {selectedType !== "custom" && duration && pricing && (
        <>
          <Title level={5}>Modules Included</Title>

          {pricing?.items?.map((module) => (
            <div
              key={module.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px 0",
                borderBottom: "1px solid #eee",
              }}
            >
              <Text>{module.Feature}</Text>
              <Text strong>${module.price}</Text>
            </div>
          ))}

          <Divider />
          <Title level={5}>Total Price: ${pricing?.total_price}</Title>
        </>
      )}

      {selectedType === "custom" && duration && (
        <>
          <Title level={5}>Select Custom Modules</Title>

          {/* <div style={{ maxHeight: "300px", overflowY: "auto" }}> */}
          <div
  style={{
    maxHeight: "calc(100vh - 350px)",
    overflowY: "auto",
    paddingRight: "10px" // prevents scrollbar overlap
  }}
>
            {customModulesList?.map((module) => (
              <div
                key={module.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "1px solid #eee",
                }}
              >
                <Checkbox
                disabled={isSaved}
                  checked={selectedModules.some((i) => i.id === module.id)}
                  onChange={(e) => handleCustomModuleSelection(e, module)}
                >
                  {module.Feature}
                </Checkbox>

                <Text strong>${module?.price}</Text>
              </div>
            ))}
          </div>

          <Divider />
          <Title level={5}>
            Total Price: $
            {selectedModules.reduce((total, module) => total + module.price, 0)}
          </Title>
        </>
      )}
    </Modal>
  );
};

export default LogbookModal;
